import { create } from 'zustand';

interface Toast { id: number; message: string; tone: 'success' | 'error' | 'info' }
interface ToastState { toasts: Toast[]; push: (message: string, tone?: Toast['tone']) => void; dismiss: (id: number) => void }

let counter = 0;
export const useToast = create<ToastState>((set) => ({
  toasts: [],
  push: (message, tone = 'success') => set((s) => ({ toasts: [...s.toasts, { id: ++counter, message, tone }] })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
